import { ELinxConnectionMethod } from 'vopay';

// The values this form actually sets PaymentSelectionMethod to — narrower than the field's
// underlying `string` type (shared with Elinx forms, which allow a comma-joined list of methods).
// Callers outside this form narrow into this type via isSinglePaymentSelectionMethod before
// passing it in, so FundingBanner itself never has to fall back on a default case.
//
// `satisfies` ties this list to ELinxConnectionMethod (minus the two values this form's switch
// doesn't handle) so it can't silently drift from the shared type — renaming/removing a value
// there breaks this array at compile time instead of leaving a stale duplicate.
const SINGLE_PAYMENT_SELECTION_METHODS = [
  'bank',
  'credit',
  'debitcard',
  'paypal',
  'venmo',
  'zelle',
  'email',
] as const satisfies readonly Exclude<ELinxConnectionMethod, 'googlepay' | 'applepay'>[];

export type SinglePaymentSelectionMethod = (typeof SINGLE_PAYMENT_SELECTION_METHODS)[number];

export function isSinglePaymentSelectionMethod(value: string | undefined): value is SinglePaymentSelectionMethod {
  // Widen to string[] here (not on the exported const) so this one comparison can accept the
  // field's wider `string` value without a cast anywhere else.
  return !!value && (SINGLE_PAYMENT_SELECTION_METHODS as readonly string[]).includes(value);
}
